module.exports = __webpack_public_path__ + "static/media/addImage.1dc856bf.svg";